import React from 'react'
import { Resource } from '../../utils/types'
import ResourceArrow from './ResourceArrow'
import { trackEvent } from '../../utils/tracking/mixpanel'
import { useMatchScreen } from '../../context/MatchScreenContext'
import '../../styles/ResourceSection/ResourceCards.scss'

interface ResourceCardProps {
    resource: Resource
}

const ResourceCard = (props: ResourceCardProps) => {
  const { articleUrl, imageUrl, title, description } = props.resource
  const { state: { pageKey } } = useMatchScreen()

  const openUrl = () => {
    trackEvent('MatchScreen', 'client-matches-article-click', {
      page_key: pageKey,
      targetUrl: articleUrl
    })
    window.open(articleUrl)
  }

  return (
        <div className="resource_card" onClick={openUrl}>
            <img
                src={imageUrl}
                className="resource_card_image"
                title="resource"
                alt="resource picture"
                style={{ width: '100%', height: 'auto' }}
            />
            <div className="resource_card_content">
                <h3 className="resource_card_title">{title}</h3>
                <p className="resource_card_description">
                    {description}
                    <span className="resource_card_link">
            read more
            <ResourceArrow />
          </span>
                </p>
            </div>
        </div>
  )
}

export default ResourceCard
